// @ts-check
import axios from 'axios';
import config from '../constants/config';

const recurringScheduleAxios = axios.create();
const recurringScheduleService = {};

/**
 * Get list of recurring schedules for this user
 * @param {import('../../../types/common').PaginationOptions} params
 * @returns
 */
recurringScheduleService.getRecurringSchedules = (params) => {
  const user = JSON.parse(localStorage.getItem('user') || '{}');
  const token = user?.token || '';
  const url = `${config.BASEURL}v2/recurringSchedules/`;
  const headers = {
    Authorization: `Bearer ${token}`,
  };

  return recurringScheduleAxios.get(url, { headers, params });
};

export default recurringScheduleService;
